import { createMemoryHistory, createRouter as createVueRouter, createWebHistory } from 'vue-router'

let hashObserver: MutationObserver | null = null
let hashObserverTimeout: number | null = null

function scrollToHashWhenReady(hash: string) {
	if (typeof document === 'undefined') return

	hashObserver?.disconnect()
	if (hashObserverTimeout !== null) window.clearTimeout(hashObserverTimeout)

	const scrollToTarget = () => {
		const target = document.querySelector(hash)
		if (!target) return false

		hashObserver?.disconnect()
		hashObserver = null
		if (hashObserverTimeout !== null) window.clearTimeout(hashObserverTimeout)
		hashObserverTimeout = null
		target.scrollIntoView({ behavior: 'smooth', block: 'start' })
		return true
	}

	if (scrollToTarget()) return

	hashObserver = new MutationObserver(scrollToTarget)
	hashObserver.observe(document.body, { childList: true, subtree: true })
	hashObserverTimeout = window.setTimeout(() => {
		hashObserver?.disconnect()
		hashObserver = null
		hashObserverTimeout = null
	}, 5000)
}

export function createRouter(mode: 'web' | 'memory' = 'web', _initialUrl = '/') {
	return createVueRouter({
		history: mode === 'memory'
			? createMemoryHistory('/')
			: createWebHistory(import.meta.env.BASE_URL),
		// Blox installs the single CMS fallback route. This router owns app routes only.
		routes: [],
		scrollBehavior(to, _from, savedPosition) {
			if (savedPosition) return savedPosition
			if (to.hash) {
				scrollToHashWhenReady(to.hash)
			}
			return { top: 0, left: 0 }
		},
	})
}

export default createRouter()
